import { render, staticRenderFns } from "./Testflow.vue?vue&type=template&id=402852c0&scoped=true"
import script from "./Testflow.vue?vue&type=script&lang=js"
export * from "./Testflow.vue?vue&type=script&lang=js"
import style0 from "./Testflow.vue?vue&type=style&index=0&id=402852c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402852c0",
  null
  
)

export default component.exports